<app-base-modal
  [title]="'Прикрепить файл'"
>
  @if (isLoading) {
    <app-loader/>
  }
  <form
    class="form"
    [formGroup]="formGroup"
  >
    @for (field of telegramSaveFileModalFields; track $index) {
        <mat-form-field appearance="outline">
          <mat-label>{{ field.label }}</mat-label>
          @if (field.isNeedInput) {
            <input
              #inputElement
              matInput
              tabindex="-1"
              class="mat-select-input"
              (focusin)="handleSelectClick(field.fieldName)"
              [(ngModel)]="selectedValue"
              (ngModelChange)="handleSearchTermChange($event, field.fieldName)"
              [ngModelOptions]="{ standalone: true }"
              (keydown)="handleKeyEvent($event, field.fieldName)"
            >
            <mat-select
              #matSelect
              [formControlName]="field.fieldName"
              (selectionChange)="handleSelectionChange($event)"
            >
              @for (option of getSelectData(field.fieldName); track option.id) {
                <mat-option [value]="option.id">
                  {{ option.id }}: {{ option.value }}
                </mat-option>
              }
            </mat-select>
          } @else {
            <mat-select [formControlName]="field.fieldName">
              @for (option of getSelectData(field.fieldName); track option.id) {
                <mat-option [value]="option.id">
                  {{option.value}}
                </mat-option>
              }
            </mat-select>
          }
        </mat-form-field>
    }
  </form>
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      type="button"
      (click)="closeDialog('cancel')"
    >
      Отмена
    </button>
    <button
      mat-button
      color="primary"
      type="button"
      [disabled]="formGroup.invalid"
      (click)="handleBind()"
    >
      Прикрепить
    </button>
  </div>
</app-base-modal>
